module.exports = __webpack_public_path__ + "static/logo-lotto4d@2x-2b3df10bd14d86ec88f4506d5af0d5d3.png";